<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar 
      title="好友转账" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div v-if="member">

      <div class="tips-panel">
        <div class="hlight title">温馨提示</div>
        <p class="details">在这里您可以将自己所拥有的孝爱币转给其他会员使用,比如您的亲戚或者朋友的会员账户上,转入时请输入对方的会员账号(对方的登录名)，必须是网上充值所的币,才可以转出，系统赠送的无法转出。</p>
        <div class="balance corange">账户余额: {{member.TotalCoinA}}孝爱币</div>
      </div>
      <van-cell-group class="form-setion">
        <van-field v-model="account" label="收款账号："  placeholder="请输入对方的登录账号"/>
      <van-field v-model="number" type="digit" label="转账金额：" placeholder="请输入转账金额" />
      </van-cell-group>
      <div class="btn-area"><van-button class="mybtn" type="info" @click="onsubmit" size="large">确认转账</van-button></div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant'
	export default {
	  data() {
	    return {
	    	account:'',
        number:'',
        member:null,
        issubmit : false,
	    };
	  },
	  components: {
    },
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
      },
      init(){
        var that = this;
        this.$store.dispatch({
          type:"GetMemberMemberInfo",
        }).then(res => {
          that.member = res;
        }, err => {})
      },
      onsubmit(){
        var that = this;
        if( !(that.number) || that.number == ''|| that.number.length == 0){
          Toast('金额不能空');
          return;
        }
        if( !(that.account) || that.account == ''|| that.account.length == 0){
          Toast('收款账号不能为空');
          return;
        }
        if(!(that.issubmit)){
          that.issubmit = true;
          this.$store.dispatch({
            type:"MemberFriendTransfer",
            otherNo: that.account,
            coin : that.number,
          }).then(res => {
            Toast(res.Message);
            if(res.IsSuccess){
              setTimeout(function (){
                that.issubmit = false;
                that.$router.go(-1);
              }, 1200)
            }else{
              that.issubmit = false;
            }
            
          }, err => {that.issubmit = false;})  
        }
      }
    },
    created(){
      this.init();
    }
	};
</script>

<style scoped>
.tips-panel{
  padding:30px 20px;
  margin-bottom: 10px;
}
.tips-panel>.title{
  font-size: 18px;
  text-align: center;
  font-weight: normal;
  margin: 15px auto;
}
.tips-panel>.details{
  font-size: 14px;
  color: #555;
}
.tips-panel>.balance{
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
}
</style>
